module.exports = __webpack_public_path__ + "static/media/train_team_response.4790e4a3.png";